// extracted by mini-css-extract-plugin
export default {"confetti-page":"style_confetti-page__TYBK5"};